export default {
  title: '站内消息',
  menu: '站内消息',
  label: {
    datetime: '创建日期',
    company: '公司',
    includeSubCompanies: '含子公司？',
    includeExclude: '可见范围',
    messageTitle: '消息标题',
    addNewNotification: '增添新消息',
    viewNotification: '查看消息',
    view: '查看',
    allCompanies: '所有公司',
    yes: '是',
    no: '否',
    excludeCompanies: '除所选公司外',
    includeCompanies: '仅所选公司',
    sendSystemNotification: '发送站内消息',
    viewSystemNotification: '查看站内消息',
    visibleCompanies: '消息可见公司',
    includeSubCompaniesLabel: '是否包含子公司',
    messageTemplate: '消息模板'
  },
  placeholder: {
    keywords: '搜索（消息内容）',
    searchCompany: '通过公司名称搜索'
  },
  message: {
    saveSiteMessageSuccess: '保存消息成功',
    saveSiteMessageFail: '保存消息失败'
  }
}
